import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const NotFoundIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "NotFoundIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M10.7328 19.4658C8.49563 19.4658 6.25801 18.6145 4.55495 16.911C1.14835 13.5044 1.14835 7.96192 4.55495 4.55532C7.96105 1.14823 13.5045 1.14823 16.9106 4.55532C20.3172 7.96192 20.3172 13.5044 16.9106 16.911C15.2075 18.6145 12.9699 19.4658 10.7328 19.4658ZM10.7328 3.51728C8.88397 3.51728 7.03566 4.22133 5.62807 5.62844C2.81336 8.44315 2.81336 13.0232 5.62807 15.8379C8.44327 18.6521 13.0223 18.6521 15.8375 15.8379C18.6522 13.0231 18.6522 8.44314 15.8375 5.62844C14.4299 4.22134 12.5816 3.51728 10.7328 3.51728Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.2411 22.0004C21.0469 22.0004 20.8528 21.9263 20.7045 21.778L15.8375 16.911C15.541 16.6145 15.541 16.1343 15.8375 15.8379C16.1339 15.5414 16.6142 15.5414 16.9106 15.8379L21.7777 20.7049C22.0741 21.0014 22.0741 21.4816 21.7777 21.778C21.6295 21.9263 21.4353 22.0004 21.2411 22.0004Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.1021 13.8528C12.9102 13.8528 12.7183 13.7796 12.5719 13.6331L7.8326 8.89433C7.53963 8.60136 7.53963 8.12675 7.8326 7.83378C8.12557 7.54081 8.60018 7.54081 8.89315 7.83378L13.6324 12.5726C13.9254 12.8655 13.9254 13.3401 13.6324 13.6331C13.4859 13.7796 13.294 13.8528 13.1021 13.8528Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.36287 13.8528C8.17098 13.8528 7.97908 13.7796 7.8326 13.6331C7.53963 13.3401 7.53963 12.8655 7.8326 12.5726L12.5719 7.83379C12.8648 7.54082 13.3394 7.54082 13.6324 7.83379C13.9254 8.12676 13.9254 8.60137 13.6324 8.89434L8.89315 13.6331C8.74667 13.7796 8.55476 13.8528 8.36287 13.8528Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default NotFoundIcon;
